























































import Vue from 'vue';
import * as pazienteApi from '../services/paziente-api';
import { PazienteList, PazienteListViewModel } from '../types';

export default Vue.extend({
    data(): PazienteListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.paziente'),
                    value: 'displayName',
                },
                {
                    text: this.$i18n.t('labels.codice-fiscale'),
                    value: 'codiceFiscale',
                },
                {
                    text: this.$i18n.t('labels.attivo'),
                    value: 'attivo',
                },
            ],
            dataItems: [],
            search: '',
            selectedItems: [],
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await pazienteApi.getList();
        },
        showDetail(item: PazienteList) {
            this.$router.push({
                name: 'PazienteDetail',
                params: { id: item.id.toString() },
            });
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await pazienteApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
    },
    mounted() {
        this.loadData();
    },
    watch: {
        $route: {
            handler: async function () {
                await this.loadData();
            },
            deep: true,
        },
    },
});
